export default __webpack_public_path__ + "static/media/4_2.c222a865.jpg";